import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">实时快讯</h2>
          <p className="text-sm text-foreground-500">7×24小时滚动更新，黑料瓜农一线速递</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div
                key={item.id}
                className={`relative pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[33px] w-6 h-6 flex items-center justify-center bg-background-50 rounded-full">
                  <div className={`w-3 h-3 rounded-full ${i === 0 ? 'bg-primary-500' : 'bg-secondary-400'}`}></div>
                </div>
                <div className="flex items-start gap-3">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                    i === 0 ? 'bg-primary-100' : 'bg-secondary-100'
                  }`}>
                    <i className={`${item.icon} text-sm ${
                      i === 0 ? 'text-primary-600' : 'text-secondary-600'
                    }`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                        i === 0
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.summary}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}